module.exports = __webpack_public_path__ + "img/saas_03.df7ea1e5.jpg";